export type PickerOptionId = string | number;

export function toSelectedArray(selected?: PickerOptionId | PickerOptionId[]): PickerOptionId[] {

  if (selected === undefined || selected === null) return [];
  const values = Array.isArray(selected) ? selected : [selected];
  return [...new Set(values)];
}

